module.exports = __webpack_public_path__ + "media/files/campari/Privacy_Policy_EN.pdf";